export const WHATSAPP_NUMBER = "905428722748";
export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const formatPrice = (n) => `${Number(n).toFixed(2).replace(".", ",")} €`;

export const FAMILIES = ["Floral", "Boisé", "Oriental", "Frais", "Gourmand"];
export const GENDERS = ["Femme", "Homme", "Mixte"];
export const SIZES = ["30", "50", "100"];

export const PAYMENT_METHODS = [
  {
    id: "virement",
    label: "Virement bancaire",
    desc: "RIB : FR32 2004 1010 1415 4434 1K03 501",
    instruction:
      "Effectuez votre virement sur le RIB ANM Paris : FR32 2004 1010 1415 4434 1K03 501 en indiquant votre code de commande dans le motif.",
  },
  {
    id: "paypal",
    label: "PayPal",
    desc: "Paiement à ngoy2032002@gmail.com",
    instruction:
      "Envoyez le montant total à ngoy2032002@gmail.com via PayPal en indiquant votre code de commande dans le motif.",
  },
  {
    id: "mpesa",
    label: "M-Pesa",
    desc: "Au 0810889805",
    instruction:
      "Envoyez le montant total par M-Pesa au 0810889805 en indiquant votre code de commande.",
  },
  {
    id: "orange_money",
    label: "Orange Money",
    desc: "Guidé via WhatsApp",
    instruction:
      "Contactez-nous directement sur WhatsApp au +90 542 872 27 48 : nous vous guiderons pas à pas pour effectuer votre paiement Orange Money.",
  },
  {
    id: "airtel_money",
    label: "Airtel Money",
    desc: "Guidé via WhatsApp",
    instruction:
      "Contactez-nous directement sur WhatsApp au +90 542 872 27 48 : nous vous guiderons pas à pas pour effectuer votre paiement Airtel Money.",
  },
  {
    id: "crypto",
    label: "Crypto — USDC (ERC20)",
    desc: "Binance, Kraken, Trust Wallet, Phantom…",
    instruction:
      "Payez en USDC (réseau ERC20) à l'adresse affichée après validation de votre commande, puis envoyez la référence de transaction par WhatsApp au +90 542 872 27 48.",
  },
];

export const PROOF_METHODS = ["mpesa", "orange_money", "airtel_money"];

export const PAYMENT_PROOF_NOTICE =
  "Important : après tout paiement par M-Pesa, Orange Money ou Airtel Money, envoyez impérativement votre preuve de paiement (capture d'écran ou référence de transaction) par WhatsApp au +90 542 872 27 48, afin que nous puissions confirmer et préparer votre commande.";

export const STATUS_STEPS = [
  { key: "recue", label: "Commande reçue" },
  { key: "preparation", label: "Préparation" },
  { key: "expediee", label: "Expédiée" },
  { key: "livraison", label: "En livraison" },
  { key: "livree", label: "Livrée" },
];
